<div [ngClass]="{ 'mat-elevation-z1 p-6 rounded': !hideElevation }">
  <div class="flex justify-between items-center mb-2">
    <h3>One more step before we can connect {{ domainName }}...</h3>
    <sbnb-button
      size="mini"
      type="primary"
      [label]="verifying ? 'Verifying...' : 'Verify Now'"
      [loading]="verifying"
      [disabled]="verifying"
      (clicked)="triggerVerification()"></sbnb-button>
  </div>
  <div class="flex flex-col gap-3">
    <!-- Warning Callout -->
    <sbnb-alert-card context="warning">
      Name server changes can take up to 48 hours to propagate. During this time, some services connected to your domain (like email) might be temporarily affected. This is
      normal and usually resolves quickly.
    </sbnb-alert-card>

    <div class="mt-6 space-y-4">
      <div>
        <h4 class="text-sm font-medium text-night-darker mb-1">Step 1: Log in to your domain registrar</h4>
        <p class="mb-0 text-sm text-night-lighter">
          Log in to the account where your domain is registered (e.g., GoDaddy, Namecheap, Google Domains).
        </p>
      </div>

      <div>
        <h4 class="text-sm font-medium text-night-darker mb-1">Step 2: Find the name server settings</h4>
        <p class="mb-0 text-sm text-night-lighter">
          Look for "DNS Settings," "Name servers" or "Domain Settings" in your registrar's dashboard.
        </p>
      </div>

      <div>
        <h4 class="text-sm font-medium text-night-darker mb-1">Step 3: Update name servers</h4>
        <div class="bg-water-lighter rounded-md p-4 mt-2">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-night-darker">Name Servers</span>
            <sbnb-copy-to-clipboard
              [content]="nameservers.join('\n')"
              [mini]="true"
              tooltipText="Copy all nameservers"></sbnb-copy-to-clipboard>
          </div>
          <div class="space-y-2">
            @for (nameserver of nameservers; track nameserver) {
              <div class="flex items-center justify-between">
                <span class="text-sm font-mono text-night-darker">{{ nameserver }}</span>
                <sbnb-copy-to-clipboard
                  [content]="nameserver"
                  [mini]="true"
                  tooltipText="Copy nameserver"></sbnb-copy-to-clipboard>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
